import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { api } from "@/api/client";

// scheduller-microservice — agente de análise financeira (integração Conta Azul).
// Porte de agente-chat.controller.js: a conversa vive só no cliente; o backend
// guarda o contexto pelo conversationId que ele mesmo devolve.
export const AGENTE_CHAT_PATH = "scheduller/Agente/Chat";

export interface AgenteRequest {
  message: string;
  /** null na primeira mensagem: o backend abre a conversa e devolve o id. */
  conversationId: string | null;
}

export interface AgenteResponse {
  conversationId: string;
  message: string;
}

export async function enviarMensagem(body: AgenteRequest): Promise<AgenteResponse> {
  const { data } = await api.post<AgenteResponse>(AGENTE_CHAT_PATH, body);
  return data;
}

/** Mesmo texto do legado: "Erro ao comunicar com o agente." + a mensagem do backend, se houver. */
export function mensagemDeErro(error: unknown): string {
  const detalhe = isAxiosError(error) ? (error.response?.data as { message?: string } | undefined)?.message : undefined;
  return detalhe ? `Erro ao comunicar com o agente. ${detalhe}` : "Erro ao comunicar com o agente.";
}

export function useEnviarMensagem() {
  // O erro vira uma bolha na conversa — sem toast global.
  return useMutation({ mutationFn: enviarMensagem, meta: { silent: true } });
}
